import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { enableFuelingService } from '../../api/fueling-service.ts';

export default function useEnableFuelingService(): UseMutationResult<
  Awaited<ReturnType<typeof enableFuelingService>>,
  Error,
  string
> {
  return useMutation({
    mutationFn: (serviceId: string) => enableFuelingService(serviceId),
  });
}
